import { LeftOutlined } from '@ant-design/icons'
import { Button, Flex } from 'antd'
import { useState } from 'react'

import { ExportDocumentIcon, ImportIcon } from 'src/assets'
import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { ImportModal } from '../components'
import { AnnuallyReportTable } from '../components/AnnuallyReportTable'

export const AnnuallyReportPage = () => {
  const { t } = useLocales()
  const [isOpenModal, setIsOpenModal] = useState(false)

  const onToggle = () => setIsOpenModal((prev) => !prev)

  return (
    <PageBreadcrumbs
      title={t('menu.reports_administration')}
      items={[{ title: t('menu.reports_administration') }]}
    >
      <Flex vertical gap={24}>
        <Flex justify="space-between">
          <Button
            icon={<LeftOutlined />}
            href={paths.reportsAdministration.root}
          >
            {t('common.back')}
          </Button>

          <Flex gap={16}>
            <Button icon={<ImportIcon />} type="primary" onClick={onToggle}>
              {t('common.import')}
            </Button>

            <Button icon={<ExportDocumentIcon />}>{t('common.export')}</Button>
          </Flex>
        </Flex>
        <AnnuallyReportTable />
      </Flex>

      {isOpenModal && <ImportModal onCancel={onToggle} />}
    </PageBreadcrumbs>
  )
}
